import PropTypes from 'prop-types';
import React from 'react';

function Payments(props) {
  const { fill } = props;
  return (
    <svg height="24" style={{ fill: 'none' }} viewBox="0 0 24 24" width="24" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M2.625 12C2.625 14.4864 3.61272 16.871 5.37087 18.6291C7.12903 20.3873 9.5136 21.375 12 21.375C14.4864 21.375 16.871 20.3873 18.6291 18.6291C20.3873 16.871 21.375 14.4864 21.375 12C21.375 9.5136 20.3873 7.12903 18.6291 5.37087C16.871 3.61272 14.4864 2.625 12 2.625C9.5136 2.625 7.12903 3.61272 5.37087 5.37087C3.61272 7.12903 2.625 9.5136 2.625 12V12Z"
        stroke={fill}
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="1.25"
      />
      <path
        d="M9.69375 14.7739C9.96424 15.1297 10.3166 15.4149 10.721 15.6053C11.1253 15.7958 11.5697 15.8857 12.0162 15.8676C13.44 15.8676 14.5938 15.0026 14.5938 13.9339C14.5938 12.8651 13.44 12.0014 12.0162 12.0014C10.5925 12.0014 9.4375 11.1351 9.4375 10.0664C9.4375 8.99765 10.5925 8.13265 12.0162 8.13265C12.4628 8.11455 12.9072 8.20453 13.3115 8.39496C13.7159 8.58538 14.0683 8.87061 14.3387 9.2264"
        stroke={fill}
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="1.25"
      />
      <path
        d="M12.0176 15.8672V17.1559"
        stroke={fill}
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="1.25"
      />
      <path d="M12.0176 6.84375V8.1325" stroke={fill} strokeLinecap="round" strokeLinejoin="round" strokeWidth="1.25" />
    </svg>
  );
}

Payments.propTypes = {
  fill: PropTypes.string.isRequired
};

export default Payments;
